// extracted by mini-css-extract-plugin
export var addToCartButton = "_qz-b";
export var arrowButtonContainer = "_qz-9";
export var arrowButtonIcon = "_qz-a";
export var carouselArrowButton = "_qz-6";
export var carouselElementContainer = "_qz-1";
export var left = "_qz-7";
export var productDisplayCarouselContainer = "_qz-0";
export var productTileContainer = "_qz-2";
export var productTileImage = "_qz-4";
export var productTileImageContainer = "_qz-3";
export var productTileTitle = "_qz-5";
export var right = "_qz-8";
export var sliderOverflow = "_qz-c";